<template>
  <div class="sidebar-mode-switcher px-3 pt-3 pb-2" v-if="canSwitch">
    <div class="btn-group btn-group-sm w-100 bg-light rounded p-1 shadow-xs border border-gray-200" role="group">
      <!-- Buton Client -->
      <button
        type="button"
        class="btn btn-xs fw-bold transition-all flex-grow-1"
        :class="{
          'btn-primary shadow-sm': userStore.currentSidebarMode === 'client',
          'btn-color-muted btn-active-color-primary bg-transparent': userStore.currentSidebarMode !== 'client'
        }"
        @click="setMode('client')"
        title="Afișează doar meniul de Client"
      >
        Client
      </button>

      <!-- Buton Contabil -->
      <button
        type="button"
        class="btn btn-xs fw-bold transition-all flex-grow-1"
        :class="{
          'btn-danger shadow-sm text-white': userStore.currentSidebarMode === 'contabil',
          'btn-color-muted btn-active-color-danger bg-transparent': userStore.currentSidebarMode !== 'contabil'
        }"
        @click="setMode('contabil')"
        title="Afișează doar meniul de Lucru Contabil"
      >
        Contabil
      </button>

      <!-- Buton Tot -->
      <button
        type="button"
        class="btn btn-xs fw-bold transition-all flex-grow-1"
        :class="{
          'btn-dark shadow-sm': userStore.currentSidebarMode === 'tot',
          'btn-color-muted btn-active-color-dark bg-transparent': userStore.currentSidebarMode !== 'tot'
        }"
        @click="setMode('tot')"
        title="Afișează ambele secțiuni"
      >
        Tot
      </button>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '../../../stores/user';

export default {
  name: 'SidebarModeSwitcher',
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  computed: {
    canSwitch() {
      if (this.$gate && typeof this.$gate.canWorkOnFirms === 'function') {
        return this.$gate.canWorkOnFirms();
      }
      return this.$gate?.isAdmin() || false;
    }
  },
  methods: {
    setMode(mode) {
      this.userStore.setSidebarViewMode(mode);
    }
  }
};
</script>

<style scoped>
.btn-xs {
  font-size: 0.72rem;
  padding: 0.25rem 0.4rem;
  border-radius: 4px;
}
.shadow-xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
</style>
